import React, { useState, useEffect } from 'react'
import { Route } from 'react-router-dom'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { useCookies } from 'react-cookie'

import MainLayout from 'layouts/main/MainLayout/MainLayout'
import CompanyMainLayout from 'layouts/company/CompanyMainLayout'

import MainFooterBar from 'components/containers/footer/MainFooterBar'

import ChristmasMainLayout from 'layouts/christmas/ChristmasMainLayout'
import MyTaskListLayout from 'layouts/task/MyTaskListLayout'
import FriendTaskListLayout from 'layouts/task/FriendTaskListLayout'

import MatchingMainLayout from 'layouts/matching/MatchingMainLayout'
import MyPageMainLayout from 'layouts/mypage/MyPageMainLayout'
import MyPageMainGuestLayout from 'layouts/mypage/MyPageMainGuestLayout'
import SettingLayout from 'layouts/mypage/SettingLayout'
import NotificationSettingLayout from 'layouts/setting/NotificationSettingLayout'

import ArchiveListLayout from 'layouts/archive/ArchiveListLayout'

import CommerceMainLayout from 'layouts/commerce/CommerceMainLayout'

// import FeedDetail from 'components/containers/feed/currentUser/FeedDetail';
import FeedLayout from 'layouts/feed/FeedLayout'

import closeWhite from 'images/icon/close_tooltip_white.png'
import { sendWebViewMsg } from 'utils/bridge'

export default function FooterLayout(props) {
  const userInfo = useSelector((state) => {
    return state.userInfo
  })
  const footerVisible = useSelector((state) => {
    return state.footerStateInfo
  })

  const [visible, setVisible] = useState(footerVisible.visible)
  let currTaskListLayout = userInfo['isLogin'] ? MyTaskListLayout : MyTaskListLayout
  let currMyPageMainLayout = userInfo['isLogin'] ? MyPageMainLayout : MyPageMainGuestLayout
  let currType =
    userInfo['role'] === 'company_member' || userInfo['role'] === 'company_admin'
      ? 'company'
      : 'normal'

  useEffect(() => {
    setVisible(footerVisible.visible)
  }, [footerVisible])

  const [cookies, setCookie, removeCookie] = useCookies()

  const [isChallengeRecommendTooltipVisible, setIsChallengeRecommendTooltipVisible] = useState(
    !!cookies['display_challenge_recommend_tooltip'],
  )

  return (
    <SectionWrapper>
      <BodyWrapper>
        <Route exact path="/feed" render={() => <FeedLayout type={currType} />} />

        <Route exact path="/" component={MainLayout} />
        <Route exact path="/company" component={CompanyMainLayout} />

        <Route exact path="/task/list" component={currTaskListLayout} />
        <Route exact path="/task/friend/:friend_no/list" component={FriendTaskListLayout} />
        <Route exact path="/task/date/:date/list" component={currTaskListLayout} />

        <Route exact path="/matching" component={MatchingMainLayout} />

        <Route exact path="/mypage" component={currMyPageMainLayout} />
        <Route exact path="/mypage/setting" component={SettingLayout} />
        <Route exact path="/mypage/setting/notification" component={NotificationSettingLayout} />

        <Route exact path="/archive" component={ArchiveListLayout} />

        <Route exact path="/motishop" component={CommerceMainLayout} />
      </BodyWrapper>
      {visible ? (
        <>
          <ChallengeRecommendTooltip visibility={isChallengeRecommendTooltipVisible.toString()}>
            🌟 추천 챌린지 보기
            <ChallengeRecommendTooltipClose
              src={closeWhite}
              onClick={(e) => {
                e.stopPropagation()
                setIsChallengeRecommendTooltipVisible(false)
                removeCookie('display_challenge_recommend_tooltip', { path: '/' })
                sendWebViewMsg({ action: 'REQ_COOKIE_FLUSH' })
              }}
            />
          </ChallengeRecommendTooltip>
          <FooterWrapper>
            <DummySpacer />
            <MainFooterBar
              onClickNavItem={(navItem) => {
                if (navItem === 'home' && !!cookies['display_challenge_recommend_tooltip']) {
                  setIsChallengeRecommendTooltipVisible(false)
                  removeCookie('display_challenge_recommend_tooltip', { path: '/' })
                  sendWebViewMsg({ action: 'REQ_COOKIE_FLUSH' })
                }
              }}
            />
          </FooterWrapper>
        </>
      ) : null}
    </SectionWrapper>
  )
}
const SectionWrapper = styled.div`
  overflow: hidden;
  height: 100vh;
  display: flex;
  flex-flow: column;
`
const BodyWrapper = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
  height: 100%;
`

const FooterWrapper = styled.div`
  flex: 0 1 auto;
  z-index: 400;
`
const DummySpacer = styled.div`
  height: calc(100vw * (61 / 375));
  width: 100%;
`

const ChallengeRecommendTooltip = styled.div`
  background-color: #ff6b00;
  color: #fff;
  position: absolute;
  left: calc(100vw * (11 / 375));
  bottom: calc(100vw * (67 / 375));
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (17 / 375));
  padding: calc(100vw * (10 / 375));
  border-radius: calc(100vw * (5 / 375));
  box-shadow: 0 calc(100vw * (9 / 375)) calc(100vw * (28 / 375)) calc(100vw * (8 / 375))
      rgba(0, 0, 0, 0.05),
    0 calc(100vw * (6 / 375)) calc(100vw * (16 / 375)) rgba(0, 0, 0, 0.08),
    0 calc(100vw * (3 / 375)) calc(100vw * (6 / 375)) calc(100vw * (-4 / 375)) rgba(0, 0, 0, 0.12);

  display: ${({ visibility }) => (visibility === 'true' ? 'flex' : 'none')};
  flex-direction: row;
  align-items: center;
  z-index: 600;

  &::after {
    content: ' ';
    position: absolute;
    bottom: calc(100vw * (-2 / 375));
    left: calc(100vw * (29 / 375));
    border-width: calc(100vw * (6 / 375));
    border-style: solid;
    border-color: #ff6b00;
    border-top-left-radius: calc(100vw * (2 / 375));
    transform: rotate(45deg);
  }
`

const ChallengeRecommendTooltipClose = styled.img`
  width: calc(100vw * (7 / 375));
  margin-left: calc(100vw * (7 / 375));
`
